import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { switchPage } from '../../../utils/api/pageControl';
import { connect } from 'react-redux';
import { enterKeyPressed } from '../../../utils/general/enterKey';

interface IReportingCalendarProps {
    source?: any;
    docHeaderSectionJson: any;
}

export class ReportingCalendar extends Component<IReportingCalendarProps, any> {
    constructor(props: IReportingCalendarProps) {
        super(props);
    }

    public render() {
        const { docHeaderSectionJson } = this.props;

        return (
            <React.Fragment>
                <div className="financials" onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, 'reportingCalendarPage'))} onClick={() => switchPage('reportingCalendarPage')}>
                    <span className="icon-corporate-calender-forecast icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.corporate + ' ' + docHeaderSectionJson.i18n.calendar} />
                    <a tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.corporate + ' ' + docHeaderSectionJson.i18n.calendar} id="financials-reporting-calendar" className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.corporate} {docHeaderSectionJson.i18n.calendar}</a>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData
    };
};

export default connect(mapStateToProps)(ReportingCalendar);
